import { Action } from 'redux';
export const GET_CITATION_INFORMATION = 'citation-page/GET_CITATION_INFORMATION';
export const GET_CITATION_INFORMATION_PAGE = 'citation-page/GET_CITATION_INFORMATION_PAGE';

export const GET_CITATION_TITLE_NAME = 'citation-page/GET_CITATION_TITLE_NAME';
export const SET_CITATION_TITLE_NAME = 'citation-page/SET_CITATION_TITLE_NAME';

export const GET_CITATION_DETAILS = 'citation-page/GET_CITATION_DETAILS';
export const GET_CITATION_DETAILS_PAGE = 'citation-page/GET_CITATION_DETAILS_PAGE';
export const GET_MANAGE_CITATION_DETAILS = 'citation-page/GET_MANAGE_CITATION_DETAILS';
export const GET_MANAGE_CITATION_DETAILS_PAGE = 'citation-page/GET_MANAGE_CITATION_DETAILS_PAGE';
export const GET_PAYMENT_TEXT = 'citation-page/GET_PAYMENT_TEXT';
export const GET_PAYMENT_TEXT_PAGE = 'citation-page/GET_PAYMENT_TEXT_PAGE';
export const GET_PAYMENT_ACCEPTED_TEXT = 'citation-page/GET_PAYMENT_ACCEPTED_TEXT';
export const GET_PAYMENT_ACCEPTED_TEXT_PAGE = 'citation-page/GET_PAYMENT_ACCEPTED_TEXT_PAGE';
export const GET_PAYMENT_DECLINED_TEXT = 'citation-page/GET_PAYMENT_DECLINED_TEXT';
export const GET_PAYMENT_DECLINED_TEXT_PAGE = 'citation-page/GET_PAYMENT_DECLINED_TEXT_PAGE';
export const GET_APPEAL_FINE_HEADER = 'citation-page/GET_APPEAL_FINE_HEADER';
export const GET_APPEAL_FINE_HEADER_PAGE = 'citation-page/GET_APPEAL_FINE_HEADER_PAGE';
export const GET_APPEAL_SENT = 'citation-page/GET_APPEAL_SENT';
export const GET_APPEAL_SENT_PAGE = 'citation-page/GET_APPEAL_SENT_PAGE';
export const UPDATE_APPEAL_SENT = 'citation-page/UPDATE_APPEAL_SENT';
export const UPDATE_APPEAL_FINE_HEADER_PAGE = 'citation-page/UPDATE_APPEAL_FINE_HEADER_PAGE';
export const UPDATE_PAYMENT_DECLINED_TEXT_PAGE = 'citation-page/UPDATE_PAYMENT_DECLINED_TEXT_PAGE';
export const UPDATE_PAYMENT_ACCEPTED_TEXT_PAGE = 'citation-page/UPDATE_PAYMENT_ACCEPTED_TEXT_PAGE';
export const UPDATE_PAYMENT_TEXT_PAGE = 'citation-page/UPDATE_PAYMENT_TEXT_PAGE';
export const UPDATE_CITATION_DETAILS_PAGE = 'citation-page/UPDATE_CITATION_DETAILS_PAGE';
export const UPDATE_CITATION_INFORMATION_PAGE = 'citation-page/UPDATE_CITATION_INFORMATION_PAGE';

/**
 * Get Citations details title Name contents
 */
export interface GetCitationsTitleNamesAction extends Action<typeof GET_CITATION_TITLE_NAME> {
  payload: any;
}

export const getCitationsTitleNamesContents = (data: any): GetCitationsTitleNamesAction => ({
  type: GET_CITATION_TITLE_NAME,
  payload: data,
});
/**
 * Set Citations details title Name contents
 */
export interface SetCitationsTitleNamesAction extends Action<typeof SET_CITATION_TITLE_NAME> {
  payload: any;
}

export const setCitationsTitleNamesContents = (data: any): SetCitationsTitleNamesAction => ({
  type: SET_CITATION_TITLE_NAME,
  payload: data,
});

/**
 * Get Citations Information Page contents
 */
export interface GetCitationsInformationAction extends Action<typeof GET_CITATION_INFORMATION> {
  payload: any;
}

export const getCitationsInformationContents = (data: any): GetCitationsInformationAction => ({
  type: GET_CITATION_INFORMATION,
  payload: data,
});

export const getCitationsInformationPageContents = () => {
  return {
    type: GET_CITATION_INFORMATION_PAGE,
  };
};

export interface GetCitationsDetailsAction extends Action<typeof GET_CITATION_DETAILS> {
  payload: any;
}

export const getCitationsDetailsContents = (data: any): GetCitationsDetailsAction => ({
  type: GET_CITATION_DETAILS,
  payload: data,
});

// citation details edit

export interface GetManageCitationsDetailsAction extends Action<typeof GET_MANAGE_CITATION_DETAILS> {
  payload: any;
}

export const getManageCitationsDetailsContents = (data: any): GetManageCitationsDetailsAction => ({
  type: GET_MANAGE_CITATION_DETAILS,
  payload: data,
});

export interface GetManageCitationsDetailsPageAction extends Action<typeof GET_MANAGE_CITATION_DETAILS_PAGE> {
  payload: any;
}
export const getManageCitationsDetailsPageContents = (data: any): GetManageCitationsDetailsPageAction => ({
  type: GET_MANAGE_CITATION_DETAILS_PAGE,
  payload: data,
});

// citation details edit end

export const getCitationsDetailsPageContents = () => {
  return {
    type: GET_CITATION_DETAILS_PAGE,
  };
};

export interface GetCitationPaymentTextAction extends Action<typeof GET_PAYMENT_TEXT> {
  payload: any;
}

export const getPaymentTextContents = (data: any): GetCitationPaymentTextAction => ({
  type: GET_PAYMENT_TEXT,
  payload: data,
});

export const getPaymentTextPageContents = () => {
  return {
    type: GET_PAYMENT_TEXT_PAGE,
  };
};

export interface GetPaymentAcceptedTextAction extends Action<typeof GET_PAYMENT_ACCEPTED_TEXT> {
  payload: any;
}

export const getPaymentAcceptedTextContents = (data: any): GetPaymentAcceptedTextAction => ({
  type: GET_PAYMENT_ACCEPTED_TEXT,
  payload: data,
});

export const getPaymentAcceptedTextPageContents = () => {
  return {
    type: GET_PAYMENT_ACCEPTED_TEXT_PAGE,
  };
};

export interface GetPaymentDeclinedTextAction extends Action<typeof GET_PAYMENT_DECLINED_TEXT> {
  payload: any;
}

export const getPaymentDeclinedTextContents = (data: any): GetPaymentDeclinedTextAction => ({
  type: GET_PAYMENT_DECLINED_TEXT,
  payload: data,
});

export const getPaymentDeclinedTextPageContents = () => {
  return {
    type: GET_PAYMENT_DECLINED_TEXT_PAGE,
  };
};

export interface GetAppealFineHeaderTextAction extends Action<typeof GET_APPEAL_FINE_HEADER> {
  payload: any;
}

export const getAppealFineHeaderContents = (data: any): GetAppealFineHeaderTextAction => ({
  type: GET_APPEAL_FINE_HEADER,
  payload: data,
});

export const getAppealFineHeaderPageContents = () => {
  return {
    type: GET_APPEAL_FINE_HEADER_PAGE,
  };
};

export interface GetAppealSentAction extends Action<typeof GET_APPEAL_SENT> {
  payload: any;
}

export const getAppealSentContents = (data: any): GetAppealSentAction => ({
  type: GET_APPEAL_SENT,
  payload: data,
});

export const getAppealSentPageContents = () => {
  return {
    type: GET_APPEAL_SENT_PAGE,
  };
};
export const updateAppealSent = (data: any) => {
  return {
    type: UPDATE_APPEAL_SENT,
    payload: data,
  };
};
export const updateAppealFIneHeaderPage = (data: any) => {
  return {
    type: UPDATE_APPEAL_FINE_HEADER_PAGE,
    payload: data,
  };
};
export const updatePaymentDeclinedText = (data: any) => {
  return {
    type: UPDATE_PAYMENT_DECLINED_TEXT_PAGE,
    payload: data,
  };
};
export const updatePaymentAccptedText = (data: any) => {
  return {
    type: UPDATE_PAYMENT_ACCEPTED_TEXT_PAGE,
    payload: data,
  };
};
export const updatePaymentText = (data: any) => {
  return {
    type: UPDATE_PAYMENT_TEXT_PAGE,
    payload: data,
  };
};
export const updateCitationDetailsPage = (data: any) => {
  return {
    type: UPDATE_CITATION_DETAILS_PAGE,
    payload: data,
  };
};
export const updateCitationInformationPage = (data: any) => {
  return {
    type: UPDATE_CITATION_INFORMATION_PAGE,
    payload: data,
  };
};

export type CitationPagesAction =
  | GetCitationsInformationAction
  | GetCitationsDetailsAction
  | GetManageCitationsDetailsAction
  | GetManageCitationsDetailsPageAction
  | GetCitationPaymentTextAction
  | GetPaymentAcceptedTextAction
  | GetPaymentDeclinedTextAction
  | GetAppealFineHeaderTextAction
  | GetCitationsTitleNamesAction
  | SetCitationsTitleNamesAction
  | GetAppealSentAction;
